import React, { Component } from 'react';

import Fab from '@material-ui/core/Fab';
import ArrowUpward from '@material-ui/icons/ArrowUpwardRounded';

interface IBackToTopState {
  intervalId: any;
}

interface IBackToTopProps {
  className?: string;
  delayInMs: number;
  scrollStepInPx: number;
}

class BackToTop extends Component<IBackToTopProps, IBackToTopState> {
  constructor(props: IBackToTopProps) {
    super(props);
    this.state = {
      intervalId: 0
    };
  }

  public scrollStep = (): void => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  public scrollToTop = (): void => {
    const intervalId = setInterval(this.scrollStep, this.props.delayInMs);
    this.setState({ intervalId });
  };

  public render(): JSX.Element {
    return (
      <div className={`back-to-top ${this.props.className || ''}`}>
        <p className="back-to-top__label">BACK TO TOP</p>
        <Fab
          size="small"
          onClick={this.scrollToTop}
          aria-label="Go Top"
          className="go-top-button override"
          color="primary"
        >
          <ArrowUpward className="go-top-button__icon override" />
        </Fab>
      </div>
    );
  }
}

export { BackToTop };
